import React, { useEffect, useState } from 'react';
import editIcon from '../img/editIcon.png';
import deleteIcon from '../img/deleteIcon.png';
import exportIcon from'../img/exportIcon.png';
import { Navigate, NavLink } from 'react-router-dom'; 
import config from "../../../../../config/config.json";
import { apiCall } from '../../../../../services/ApiCall.js';
import styled from 'styled-components';
import { 
  FaEdit,
  FaTrash,
  FaDownload,
  FaPlus,
  FaSearch,
  FaBuilding,
  FaUser,
  FaHistory
} from 'react-icons/fa';

// Styled Components for modern design
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
`;

const MainCard = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 2rem;
`;

const HeaderSection = styled.div`
  background: linear-gradient(135deg, #0d6efd 0%, #4285f4 100%);
  color: white;
  padding: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const Title = styled.div`
  color: white;
  font-size: 2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 1rem;
  
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

const HeaderButtons = styled.div`
  display: flex;
  gap: 1rem;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const HeaderButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  border: none;
  
  &.history-btn {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-1px);
    }
  }
  
  &.export-btn {
    background: white;
    color: #0d6efd;
    border: 1px solid white;
    
    &:hover {
      background: #f8f9fa;
      transform: translateY(-1px);
    }
  }
`;

const ActionBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  background: white;
  gap: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const AddCompanyButton = styled.button`
  background: linear-gradient(135deg, #0d6efd 0%, #4285f4 100%);
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  text-decoration: none;
  
  &:hover {
    background: linear-gradient(135deg, #0a58ca 0%, #1a73e8 100%);
    transform: translateY(-2px);
    color: white;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  flex: 1;
  max-width: 70%;
  
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 3rem;
  border: 2px solid #0d6efd;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 2rem;
`;

const SectionHeader = styled.div`
  background: linear-gradient(135deg, #0d6efd 0%, #4285f4 100%);
  color: white;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SectionTitle = styled.span`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const IconButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.1);
  }
  
  img {
    background: #E6F1F7;
    border: 1px solid #E6F1F7;
    border-radius: 50%;
    padding: 8px;
  }
`;

const AddContactButton = styled.button`
  background: #E6F1F7;
  color: #0d6efd;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  margin-right: 1rem;
  
  &:hover {
    background: #d4e7fd;
    transform: translateY(-1px);
  }
`;

const SectionContent = styled.div`
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
`;

const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: ${props => props.last ? '0' : '1.5rem'};
  color: #0d6efd;
  gap: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const InfoItem = styled.div`
  flex: 0 1 18%;
  min-width: 150px;
  
  @media (max-width: 768px) {
    flex: 1 1 100%;
  }
  
  strong {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.875rem;
    letter-spacing: 0.5px;
  }
`;

const StatusBadge = styled.span`
  background-color: ${props => props.active ? '#48AB57' : '#48AB57'};
  padding: 5px 10px;
  color: white;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  display: inline-block;
`;

const ContactInfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 15px;
  color: #0d6efd;
  gap: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const ContactItem = styled.div`
  flex: 0 1 18%;
  min-width: 200px;
  
  @media (max-width: 768px) {
    flex: 1 1 100%;
  }
  
  strong {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.875rem;
    letter-spacing: 0.5px;
  }
  
  span {
    color: #212529;
    font-weight: 500;
  }
`;

// EXACT ORIGINAL COMPONENT WITH PRESERVED LOGIC - NO CHANGES TO FUNCTIONALITY
const ViewPage = ({ id, company, address, city, state, zipcode, status, onEdit }) => {
  // EXACT ORIGINAL STATE - NO CHANGES
  const [companyContactData, setCompanyContactData] = useState({});

  // EXACT ORIGINAL API FUNCTION - NO CHANGES
  const getCompanyContact = async () => {
    const { isSuccess, data } = await apiCall(
      `${config.POST_LOGIN_API_URL}getCompanyContact`,
      {},
      {companyId:id},
      "GET"
    );
    if (isSuccess) {
      setCompanyContactData(data?.data);
    }
  };

  // EXACT ORIGINAL useEffect - NO CHANGES
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      Navigate("/");
    }
    getCompanyContact();
  }, [id]);

  return (
    <Container>
      {/* Header Section - Modern layout, same functionality */}
      <MainCard>
        <HeaderSection>
          <Title>
            <FaBuilding />
            Company Details
          </Title>
          <HeaderButtons>
            <HeaderButton className="history-btn">
              <FaHistory />
              History
            </HeaderButton>
            <HeaderButton className="export-btn">
              <img src={exportIcon} alt="Export" style={{ marginRight: '0.5rem', width: '16px', height: '16px' }} />
              Export
            </HeaderButton>
          </HeaderButtons>
        </HeaderSection>

        {/* Action Bar - Preserving exact original structure */}
        <ActionBar>
          <NavLink to="/add-company" style={{ textDecoration: 'none' }}>
            <AddCompanyButton>
              + Add Company
            </AddCompanyButton>
          </NavLink>
          
          <SearchContainer>
            <SearchIcon>
              <FaSearch />
            </SearchIcon>
            <SearchInput
              type="text"
              placeholder="Search..."
            />
          </SearchContainer>
        </ActionBar>
      </MainCard>

      {/* Company Details Section - Preserving exact original data structure */}
      <SectionCard>
        <SectionHeader>
          <SectionTitle>
            <FaBuilding />
            Company Details
          </SectionTitle>
          <ActionButtons>
            <IconButton onClick={onEdit}>
              <img src={editIcon} alt="Edit" />
            </IconButton>
            <IconButton>
              <img src={deleteIcon} alt="Delete" />
            </IconButton>
          </ActionButtons>
        </SectionHeader>

        <SectionContent>
          {/* First row - exactly as original */}
          <InfoRow>
            <InfoItem>
              <strong>ARA ID</strong>
              {id}
            </InfoItem>
            <InfoItem>
              <strong>Name</strong>
              {companyContactData?.companyData?.name}
            </InfoItem>
            <InfoItem>
              <strong>Street</strong>
              {companyContactData?.companyData?.street}
            </InfoItem>
            <InfoItem>
              <strong>Street 2</strong>
              {companyContactData?.companyData?.street2}
            </InfoItem>
            <InfoItem>
              <strong>State</strong>
              {companyContactData?.companyData?.state}
            </InfoItem>
          </InfoRow>

          {/* Second row - exactly as original with pt-4 equivalent spacing */}
          <InfoRow last style={{ paddingTop: '1rem' }}>
            <InfoItem>
              <strong>City</strong>
              {companyContactData?.companyData?.city}
            </InfoItem>
            <InfoItem>
              <strong>Zipcode</strong>
              {companyContactData?.companyData?.zipcode}
            </InfoItem>
            <InfoItem>
              <strong>Office Type</strong>
              {companyContactData?.companyData?.officeType}
            </InfoItem>
            <InfoItem>
              <strong>Status</strong>
              <StatusBadge active={status === 'Active'}>
                {companyContactData?.companyData?.status === 0 ? 'Active' : 'Inactive'}
                <span>   </span>
              </StatusBadge>
            </InfoItem>
            <InfoItem>
              {/* Blank space for alignment purposes - exactly as original */}
            </InfoItem>
          </InfoRow>
        </SectionContent>
      </SectionCard>

      {/* Main Contact Section - Preserving exact original structure */}
      <SectionCard style={{ marginTop: '20px' }}>
        <SectionHeader>
          <SectionTitle>
            <FaUser />
            Main Contact
          </SectionTitle>
          <ActionButtons>
            <AddContactButton className="ps-2 pe-2">
              + Add New Contact
            </AddContactButton>
            <IconButton onClick={onEdit}>
              <img src={editIcon} alt="Edit" />
            </IconButton>
            <IconButton>
              <img src={deleteIcon} alt="Delete" />
            </IconButton>
          </ActionButtons>
        </SectionHeader>

        <SectionContent>
          {/* Contact info - exactly as original */}
          <ContactInfoRow>
            <ContactItem>
              <strong>Name</strong>
              <span>Archie Bizmark </span>
            </ContactItem>
            <ContactItem>
              <strong>Phone</strong>
              <span>8438514377</span>
            </ContactItem>
            <ContactItem>
              <strong>DESIGNATION</strong>
              <span>Site Admin</span>
            </ContactItem>
            <ContactItem>
              <strong>EMAIL</strong>
              <span>1stchoice@recoveryagents.net</span>
            </ContactItem>
          </ContactInfoRow>
        </SectionContent>
      </SectionCard>
    </Container>
  );
};

export default ViewPage;